import { actions } from './actions'

const initialState = {
  productosDesayuno: {
    data: [],
    loading: false,
    error: '',
  },

  categorias: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function productosDesayunoReducer(state = initialState, action) {
  switch (action.type) {
    case actions.PRODUCTOS_DESAYUNO_LOAD_REQUESTED:
      return { ...state, productosDesayuno: { ...state.productosDesayuno, loading: true } }
    case actions.PRODUCTOS_DESAYUNO_LOAD_SUCCEEDED:
      return {
        ...state,
        productosDesayuno: { ...state.productosDesayuno, data: action.payload, loading: false },
      }
    case actions.PRODUCTOS_DESAYUNO_LOAD_FAILED:
      return {
        ...state,
        productosDesayuno: { ...state.productosDesayuno, loading: false, error: action.error },
      }

    case actions.PRODUCTOS_DESAYUNO_CATEGORIAS_REQUESTED:
      return { ...state, categorias: { ...state.categorias, loading: true } }
    case actions.PRODUCTOS_DESAYUNO_CATEGORIAS_SUCCEEDED:
      return {
        ...state,
        categorias: { ...state.categorias, data: action.payload, loading: false },
      }
    case actions.PRODUCTOS_DESAYUNO_CATEGORIAS_FAILED:
      return {
        ...state,
        categorias: { ...state.categorias, loading: false, error: action.error },
      }

    case actions.PRODUCTOS_DESAYUNO_UPDATE_REQUESTED:
      return {
        ...state,
        productosDesayuno: { ...state.productosDesayuno, loading: true, error: '' },
      }
    case actions.PRODUCTOS_DESAYUNO_UPDATE_SUCCEEDED:
      return {
        ...state,
        productosDesayuno: {
          ...state.productosDesayuno,
          data: state.productosDesayuno.data.map(p =>
            p.id === action.payload.id ? action.payload : p,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.PRODUCTOS_DESAYUNO_UPDATE_FAILED:
      return {
        ...state,
        productosDesayuno: { ...state.productosDesayuno, loading: false, error: action.error },
      }

    default:
      return state
  }
}
